'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.0.14.11@react-slick/lib/index.js
 ** module id = 321
 ** module chunks = 0 1
 **/